import { render } from "./LoginSplitScreen.vue?vue&type=template&id=0f8b8143"
const script = {}

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__